import React from 'react';

export const TableHeader = ({ UImobile }) => (
    <thead className="kt-datatable__head">
    <tr className="kt-datatable__row">
        <th width="120px" className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>№</span>
        </th>
        <th
            style={{textAlign: 'left'}}
            width="165px"
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Дата</span>
        </th>
        <th
            style={{ textAlign: 'center' }}
            width="165px"
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Поставщик</span>
        </th>
        <th
            width="165px"
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Филиал</span>
        </th>
        <th
            width="auto"
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Примечание</span>
        </th>
        <th
            style={{textAlign: 'center'}}
            width="200px"
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Оплата</span>
        </th>
        <th
            style={{textAlign: 'center'}}
            width="165px"
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Сумма</span>
        </th>
        <th
            style={{textAlign: 'center'}}
            width="125px"
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Дата оплаты</span>
        </th>
        <th
            style={{textAlign: 'right'}}
            width="180px"
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Действия</span>
        </th>
    </tr>
    </thead>
);